import { render, staticRenderFns } from "./carcoupongiveout.vue?vue&type=template&id=2b6d496f&scoped=true&"
import script from "./carcoupongiveout.vue?vue&type=script&lang=js&"
export * from "./carcoupongiveout.vue?vue&type=script&lang=js&"
import style0 from "./carcoupongiveout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./carcoupongiveout.vue?vue&type=style&index=1&id=2b6d496f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d496f",
  null
  
)

export default component.exports